import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import {initReactI18next} from 'react-i18next'
import {readLanguageFromPath, SUPPORTED_LANGUAGES} from './config/languages'

// Always-mounted chrome. Everything else loads on demand.
// Must never be empty or contain i18next's built-in "translation", which has no file here.
const preloadedNamespaces = [
    'common',
    'navbar',
    'footer',
    'errors',
]

const {language} = readLanguageFromPath(window.location.pathname)

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        lng: language,
        fallbackLng: 'en',
        // debug: false,
        supportedLngs: [...SUPPORTED_LANGUAGES],
        load: 'languageOnly', // "en-US" must not request a locale file we do not ship
        ns: preloadedNamespaces,
        defaultNS: 'common',
        detection: {
            caches: ['localStorage', 'cookie']
        },
        interpolation: {
            escapeValue: false
        },
        backend: {
            loadPath: '/locales/{{ns}}/{{lng}}.json'
        }
    })

export default i18n
